import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDuplicatesRemoveLimitWarningModal = (groupsToDelete: number) => {
    openPopupHelper({
        popupName: popupNames.DUPLICATES_REMOVE_LIMIT_WARNING_MODAL,
        data: {
            count: groupsToDelete,
        },
    });
};
